import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import AddIcon from "../../../assets/images/AddIcon.svg";

interface MainCardsProps {
  title?: string;
  children: React.ReactNode;
  dropdownOptions?: string[];
  selectedValue?: string;
  onDropdownChange?: (value: string) => void;
  maxHeight?: string;
  minHeight?: string;
  cardMaxHeight?: string;
  addButton?: boolean;
  onButtonClick?: () => void;
  paddingBottom?: string;
}

const MainCards: React.FC<MainCardsProps> = ({
  title,
  children,
  dropdownOptions,
  selectedValue,
  addButton,
  onButtonClick,
  onDropdownChange,
  maxHeight,
  minHeight,
  cardMaxHeight,
  paddingBottom,
}) => {
  return (
    <Card
      elevation={0}
      square
      sx={{
        borderRadius: 0,
        overflow: "hidden",
        maxHeight: maxHeight || "255px",
        background: "#5D5D5D",
        minHeight: { xs: "fit-content", sm: minHeight || "255px" },

        color: "#ffffff",
      }}
    >
      {title && (
        <Box
          sx={{
            backgroundColor: "#212121",
            padding: 1.5,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* title section--------------- */}
          <Typography fontWeight="bold" color="#FFFFFF" className="f-16">
            {title}
          </Typography>
          <Box sx={{ display: "flex" }}>
            {dropdownOptions && onDropdownChange && (
              <Select
                value={selectedValue || ""}
                onChange={(e) => onDropdownChange(e.target.value)}
                variant="standard"
                sx={{
                  color: "white",
                  fontSize: "12px",
                  minWidth: "100px",
                  paddingBottom: "2px",
                  "& .MuiSelect-select": {
                    paddingY: 0,
                  },
                  "& .MuiSelect-icon": { color: "#ffffff" },
                  "&:before": { borderBottom: "1px solid #808080 !important" },
                  "&:after": { borderBottom: "1px solid #808080 !important" },
                  "&:hover:not(.Mui-disabled):before": {
                    borderBottom: "1px solid #808080 !important",
                  },
                }}
                displayEmpty
              >
                {dropdownOptions.map((option, index) => (
                  <MenuItem key={index} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            )}
            {addButton && onButtonClick && (
              <Button
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  padding: "0px",
                  width: "fit-content",
                  minWidth: "fit-content",
                  ml: 2,
                }}
              >
                <img
                  src={AddIcon}
                  alt="Add"
                  width={20}
                  height={20}
                  onClick={onButtonClick}
                />
              </Button>
            )}
          </Box>
          {/* Dropdown section --------------- */}
        </Box>
      )}
      {/* card content------------- */}
      <CardContent
        className="scrollbar"
        sx={{
          padding: 0,
          overflowY: "auto",
          maxHeight: cardMaxHeight || "280px",

          paddingBottom: paddingBottom,
        }}
      >
        {children}
      </CardContent>
    </Card>
  );
};

export default MainCards;
